import Inputc from '../../components/input.vue'
import PhoneId from '../../components/phoneId.vue'
import {api, msg} from "../../common/config";
import {StorageUtil} from '../../common/Auth.js';
import {ajaxUtil} from '../../common/AjaxUtil.js';
import {CommonUtil} from '../../common/CommonUtil.js';
import {validateUtil} from '../../common/ValidateUtil.js';
import {store} from '../../store/store.js'

export default {
    name: 'addphone',
    components: {
        Inputc,
        PhoneId,
    },
    data() {
        return {
            phone: "",
            verificationCode: "",
            isPhoneId: false,
            otherIdCard: "",
            sendPassword: {
                canClick: true,
                value: "发送验证码",
                countNumber: "",
            },
            isSend: 0,//0未发送,1发送
        }
    },
    mounted() {
        if (store.func.getUserObj() == null) {
            store.index.$refs.login.showLogin();
            return;
        }
        if (store.func.getUserObj().phone != '') {
            this.$router.push('/borrow');
        }
        /* var url = api.personalnews.overdue.replace('{idCard}', store.user.idCard);
         ajaxUtil.ajaxJson(url, null, 'GET', (data) => {
         }, (result) => {
           if (result.errorCode == 30100) {
             if (result.message === '登录超时,请重新登录'){
               store.index.$refs.login.showLogin();
               return;
             }
             // this.$router.push('/loginin');
           }
        }, this);*/
    },
    methods: {
        close() {
            this.isPhoneId = false;
        },
        sendVerificationCode: function () {
            var phoneMsg = validateUtil.validate([{name: 'phone'}, {name: 'required'}], this.phone);
            if (phoneMsg != null) {
                this.$refs.a.showError(msg.phoneError);
                return;
            }
            if (!this.sendPassword.canClick) {
                return
            }
            //判断手机号是否已经存在
            ajaxUtil.ajaxJson(api.reader.preUserInfo.replace("{phone}", this.phone), "", "get", ((data) => {
                if (data != null && data.baseInfo != null) {
                    this.otherIdCard = data.baseInfo.idCard;
                    this.isPhoneId = true;
                } else {
                    this.popClick();
                }
            }), ((data) => {
                CommonUtil.setInfo(msg.phoneError);
            }), this);
        },
        //绑定新身份证
        popClick() {
            var url = api.reader.modifySend;
            ajaxUtil.ajaxJson(url, {'phone':this.phone}, "post", ((data) => {
                this.isPhoneId = false;
                this.isSend = 1;
                this.countdown(60);
                CommonUtil.setInfo("验证码已发送!");
            }), (data) => {
                CommonUtil.setInfo(msg.sendCodeError);
            }, this);
        },

        //使用原来的身份证
        original: function () {
            this.isPhoneId = false;
            this.phone = "";
            this.verificationCode = "";
            /* this.$router.push({path: '/loginin', query: {idCard: this.otherIdCard}});*/
        },

        confirmBtn: function () {
            if (this.phone.trim() == "" || this.verificationCode.trim() == "") {
                this.$refs.a.showError("请输入手机号!");
                return;
            }
            var phoneMsg = validateUtil.validate([{name: 'phone'}, {name: 'required'}], this.phone);
            if (phoneMsg != null) {
                this.$refs.a.showError(msg.phoneError);
                return;
            }
            if (this.verificationCode.length != 4) {
                this.$refs.b.showError("验证码错误!");
                return;
            }
            var paramDto = {};
            paramDto.idCard = StorageUtil.getObject("user").idCard;
            paramDto.phone = this.phone;
            paramDto.code = this.verificationCode;
            ajaxUtil.ajaxJson(api.reader.modifyPhone, paramDto, "POST", ((data) => {
                var user = StorageUtil.getObject("user");
                user.phone = this.phone;
                store.user = user;
                StorageUtil.storeObject("user", user);
                CommonUtil.setInfo("绑定手机号成功!");
                this.verificationCode = "";
                CommonUtil.changeURLPar();
            }), ((result) => {
                if (result.errorCode == 30106) {
                    this.verificationCode = "";
                    CommonUtil.setInfo(msg.codeError);
                } else {
                    CommonUtil.setInfo("绑定手机号失败!");
                }
            }), this);
        },
        //倒计时
        countdown: function (initCount) {
            if (initCount < 0) {
                return
            }
            var _this = this;
            _this.sendPassword.canClick = false;
            _this.sendPassword.value = "秒后再次发送";
            var intervalId = setInterval(function () {
                initCount--;
                if (initCount <= 0) {
                    clearInterval(intervalId);
                    _this.sendPassword.countNumber = "";
                    _this.sendPassword.canClick = true;
                    var value;
                    if (_this.isSend == 1) {
                        value = "再次发送";
                    } else {
                        value = "发送验证码";
                    }
                    _this.sendPassword.value = value;
                    return;
                } else {
                    _this.sendPassword.countNumber = initCount;
                }
            }, 1000);
        },

    }
}
